import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ErrorPage from '../components/ErrorPage';
import { MigrationSwitch } from '../components/MigrationSwitch';
import {
  OnboardingBankStepSkeleton,
  OnboardingProfileStepSkeleton,
  OnboardingWorkspaceStepSkeleton,
} from '../components/onboarding/OnboardingSkeletons';
import { FEATURE_FLAGS } from '../constant/featureFlags';
import { ProtectLazyLoadRoute } from './LazyLoadElement';

const OnboardingLayout = lazy(() => import('../layout/OnboardingLayout'));
const OnboardingLayoutV3 = lazy(() =>
  import('../layout/OnboardingLayoutV3').then((m) => ({
    default: m.OnboardingLayoutV3,
  })),
);
const CreateProfileV2 = lazy(() => import('../pages/Onboarding/CreateProfile'));
const CreateProfileV3 = lazy(() =>
  import('../pages/v3/Onboarding/CreateProfile').then((m) => ({
    default: m.CreateProfile,
  })),
);
const SetupWorkspaceV2 = lazy(
  () => import('../pages/Onboarding/SetupWorkspaceV2'),
);
const SetupWorkspaceV3 = lazy(() =>
  import('../pages/v3/Onboarding/SetupWorkspace').then((m) => ({
    default: m.SetupWorkspace,
  })),
);
const BankDetailsV2 = lazy(() => import('../pages/Onboarding/BankDetailsV3'));
const BankDetailsV3 = lazy(() =>
  import('../pages/v3/Onboarding/BankDetails').then((m) => ({
    default: m.BankDetails,
  })),
);

export const OnboardingRoutes: RouteObject[] = [
  {
    element: (
      <MigrationSwitch
        featureFlags={FEATURE_FLAGS.MSR3_ONBOARDING_ROUTE}
        newComponent={ProtectLazyLoadRoute(OnboardingLayoutV3)}
        oldComponent={ProtectLazyLoadRoute(OnboardingLayout)}
      />
    ),
    loader: () => {
      return {
        // Passing null allows access even when they don't have a profile or any roles
        // But still requires an auth0 session
        permissionRequired: null,
      };
    },
    children: [
      {
        children: [
          {
            path: 'create-profile',
            element: (
              <MigrationSwitch
                featureFlags={FEATURE_FLAGS.MSR3_ONBOARDING_ROUTE}
                newComponent={ProtectLazyLoadRoute(
                  CreateProfileV3,
                  <OnboardingProfileStepSkeleton />,
                )}
                oldComponent={ProtectLazyLoadRoute(CreateProfileV2)}
              />
            ),
            loader: () => {
              return {
                permissionRequired: null,
              };
            },
            handle: { skipWorkspaceSync: true },
          },
          {
            path: 'setup-workspace',
            element: (
              <MigrationSwitch
                featureFlags={FEATURE_FLAGS.MSR3_ONBOARDING_ROUTE}
                newComponent={ProtectLazyLoadRoute(
                  SetupWorkspaceV3,
                  <OnboardingWorkspaceStepSkeleton />,
                )}
                oldComponent={ProtectLazyLoadRoute(SetupWorkspaceV2)}
              />
            ),
            loader: () => {
              return {
                permissionRequired: [PermissionEnum.EditWorkspaceDetails],
              };
            },
          },
          {
            path: 'bank-details',
            element: (
              <MigrationSwitch
                featureFlags={FEATURE_FLAGS.MSR3_ONBOARDING_ROUTE}
                newComponent={ProtectLazyLoadRoute(
                  BankDetailsV3,
                  <OnboardingBankStepSkeleton />,
                )}
                oldComponent={ProtectLazyLoadRoute(BankDetailsV2)}
              />
            ),
            loader: () => {
              return {
                permissionRequired: [PermissionEnum.EditBankDetails],
              };
            },
          },
        ],
        errorElement: <ErrorPage genericError />,
      },
    ],
  },
];
